import React from 'react';

import { Container, Illustration, TextContainer } from './Maintenance.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { MAINTENANCE_ERROR_MESSAGE } from 'utilities/constants';
import { clearMaintenanceMode } from 'utilities/maintenanceMode';
import { pageUrl } from 'utilities/pageUrl';

export const Maintenance = () => {
  const handleBackToLogin = () => {
    clearMaintenanceMode();
    // Use full page navigation to re-evaluate maintenance guard in Router
    window.location.href = pageUrl.login();
  };

  return (
    <Container>
      <div>
        <Illustration src="/notFound.svg" alt="Maintenance" />
      </div>
      <TextContainer>
        <Heading tag="h1" styledAs="h1" noMargin>
          Maintenance In Progress
        </Heading>
        <Text tag="p" size="lg">
          {MAINTENANCE_ERROR_MESSAGE}
        </Text>
        <Button label={'Back to Login'} category="primary" onClick={handleBackToLogin} />
      </TextContainer>
    </Container>
  );
};
